import React, { useState, useContext, useEffect } from "react";
import { Button , Col } from "react-bootstrap";
import "../../../DataCollection/style.css";
import { VscBellDot } from "react-icons/vsc";
import style from "../Notifications.module.scss";
import { FaDatabase } from "react-icons/fa";
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { NotificationService } from "../../../../HttpService/NotificationService";
import AuthContext from '../../../../auth/authContext';

const RecentNotifications = () => {
    const navigate = useNavigate();
    const { user } = useContext(AuthContext); // Asumiendo que tienes un contexto de autenticación
  
    const [filteredNotifications, setFilteredNotifications] = useState([]);
  
    useEffect(() => {
      async function fetchNotifications() {
        try {
          const notifications = await new NotificationService("workflow/notifications/" + user.username).getNotifications({ limit: 500 });
          const lastFourNotifications = notifications.slice(-4).reverse();
          const modifiedNotifications = lastFourNotifications.map(notification => {
            const startIndex = notification.message.indexOf("has");
            const endIndex = notification.message.indexOf("task.");
            const filteredMessage = notification.message.substring(startIndex, endIndex + 4);
            return {
              ...notification,
              message: filteredMessage,
            };
          });
          setFilteredNotifications(modifiedNotifications);
        } catch (error) {
          console.log("Error al obtener las notificaciones:", error);
        }
      }
  
      fetchNotifications();
    }, [user.username]);
  
    return (
      <Col xxl={3} xl={3} lg={3} md={12} sm={12}>
        <div className={`${style.recentNotificationPanel} ${"p-4"}`}>
          <h4>
            <VscBellDot size="24" className="me-2" color="#fff" /> Recent Notifications
          </h4>
          <hr size="5" style={{ opacity: "1" }} />
          <ul className="m-0 p-0 w-100">
            {filteredNotifications.map((notification, index) => (
              <li key={index} className={`${style.notificationsBorder} ${"d-flex flex-row align-items-center justify-content-start w-100 py-3"}`}>
                <div className={style.notificationAvatar}>AA</div>
                <div className="flex-grow-1" style={{ paddingLeft: '1rem' }}>
                  <h6 className="fw-bold">
                    <span className="fw-lighter">{user.username} </span>
                    {notification.message} #{notification.taskId}
                  </h6>
                  <div className="d-flex flex-row justify-content-between">
                    <small>{notification.createdAt}</small>
                    <small><FaDatabase size="12" className="me-1" color="#fff" /> Data Collection Request</small>
                  </div>
                </div>
              </li>
            ))}
          </ul>
          <div className="pt-3 d-flex justify-content-end">
            <Button variant="outline-light" type="submit" onClick={() => navigate("/TODIS-APP/WorkFlow/notifications")} style={{ borderRadius: "12px", padding: "8px 27px" }}>
              VIEW ALL &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<BsArrowRight size={18} />
            </Button>
          </div>
        </div>
      </Col>
    )
  }
  
  export default RecentNotifications;